import { ResourceManager } from "@/components/admin/ResourceManager";

export const AdminProducts = () => (
  <ResourceManager
    title="Produk"
    description="Kelola varian madu yang tampil di halaman Produk."
    queryKey="products"
    endpoint="/products"
    columns={[
      {
        key: "image",
        label: "Foto",
        render: (p) => (
          <img src={p.image} alt={p.name} className="h-12 w-12 rounded-lg object-cover" />
        ),
      },
      { key: "name", label: "Nama" },
      { key: "price", label: "Harga" },
      { key: "unit", label: "Satuan" },
      { key: "tag", label: "Label" },
    ]}
    fields={[
      { name: "name", label: "Nama Produk", type: "text" },
      { name: "price", label: "Harga (mis. Rp 95.000)", type: "text" },
      { name: "unit", label: "Satuan (mis. 250 ml)", type: "text" },
      { name: "tag", label: "Label (mis. Terlaris)", type: "text" },
      { name: "desc", label: "Deskripsi", type: "textarea" },
      { name: "image", label: "Foto Produk", type: "image" },
      { name: "position", label: "Urutan Tampil", type: "number" },
    ]}
  />
);
